<template>
  <div>
    <div class="vgt-center-align vgt-text-disabled">
      {{message}}
    </div>
  </div>
</template>

<script>


  export default {
    name: "TableEmptyState",
    data () {
      return {
        message: "No hay datos." 
      }
    },
    props: { 
    },
    methods: {
    }
  }
</script>

<style scoped>

</style>